export const minLength = length => `※ ${length}文字以上で入力してください。`;

export const maxLength = length => `※ ${length}文字以下で入力してください。`;

export const justLength = length => `※ ${length}文字で入力してください。`;

export const mustBeNumber = field => `※ ${field}は数値のみ入力してください。`;

export const maxLengthWithLine = (length, valid) => `※ 1行の文字数は${length}文字までです。(${valid}行目)`



// WEBPACK FOOTER //
// ./src/validation/i18n/ja.js